import type { SortCondition } from './types';

/**
 * SortCondition[] をバックエンドの `sort` クエリパラメータ形式に変換する。
 *
 * 出力は `field` または `field:desc` 形式の配列。
 * `asc` は BE 側の既定値のため省略し、コロン無しのフィールド名のみを送る。
 * 条件が空の場合は `undefined` を返し、API 呼び出し側で `sort` パラメータ自体を省略できるようにする。
 */
export const toApiSortParam = <ColumnId extends string>(
  conditions: readonly SortCondition<ColumnId>[] | undefined,
): string[] | undefined => {
  if (!conditions || conditions.length === 0) return undefined;
  return conditions.map((c) => (c.order === 'desc' ? `${c.columnId}:desc` : c.columnId));
};
